import React, { Component } from 'react';
import { adminservice } from '../../../services/admin.service';

class DeleteQuestionBankModel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedQuestionIdToDelete:'0',
            showErrorMessage:false,
            showQAforMEO:false,
        };
    }

    componentDidMount=()=>{
        this.setState({
            selectedQuestionIdToDelete:this.props.selectQuestionIdToDelete,
            showQAforMEO:this.props.showQAforMEO,
        })
    }

    deleteQuestion=async()=>{
        const{selectedQuestionIdToDelete,showQAforMEO}=this.state;
        if(showQAforMEO){
            var response=await adminservice.DeleteSelectedQuestionforMeo(selectedQuestionIdToDelete);
            if(response.status === 200){
                this.props.clearEditModel()
            }else{
                this.setState({
                    showErrorMessage:true,
                })
            }
        }else{
            var response=await adminservice.DeleteSelectedQuestion(selectedQuestionIdToDelete);
            if(response.status === 200){
                this.props.clearEditModel()
            }else{
                this.setState({
                    showErrorMessage:true,
                })
            }
        }
    }
    render() {
        const{showErrorMessage}=this.state;
        return (
            <div className="modal update-unit-popup" id="myModal1">
                <div className="modal-dialog modal-dialog-centered modal-dialog-md">
                    <div className="modal-content">
                    {/* Modal Header */}
                    <div className="modal-header" style={{padding:'9px 1rem'}}>
                        <h4 className="modal-title">Delete Question Bank</h4>
                        <button type="button" className="btn-close" onClick={()=>this.props.clearEditModel()}>X</button>
                    </div>
                    {/* Modal body */}
                    <div className="modal-body" style={{overflowX: 'auto', padding: '30px'}}>
                        <h5 style={{fontWeight: 400, fontSize: '22px'}}>Are you sure you want to delete the Question Bank?</h5>
                        {showErrorMessage && (
                                <small
                                id="emailHelp"
                                className="form-text"
                                style={{ color: "red" }}
                                >
                                Erro while deleting file
                                </small>
                            )}
                    </div>
                    {/* Modal footer */}
                    <div className="modal-footer">
                        <button type="button" className="btn Submit-btn" onClick={()=>this.deleteQuestion()}>OK</button>
                        <button type="button" className="btn Cancel-btn" onClick={()=>this.props.clearEditModel()}>CANCEL</button>
                    </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default DeleteQuestionBankModel;